import classNames from 'classnames';
import { HippoComponentProps } from '../index';
import React from 'react';

import styles from './Countdown.module.scss';

export interface Props extends HippoComponentProps {
  number: number;
  onCountdownChange?: (number: number) => void;
  onCountdownEnd?: () => void;
}

const Countdown: React.FC<Props> = ({
  dataQA,
  className,
  number: defaultNumber,
  onCountdownChange,
  onCountdownEnd,
}) => {
  const [number, setNumber] = React.useState(defaultNumber);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNumber(prevNumber => {
        if (prevNumber === 1) {
          onCountdownEnd?.();
          clearInterval(interval);
        }

        onCountdownChange?.(prevNumber - 1);
        return prevNumber - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      <span>{number}</span>
    </div>
  );
};

export default Countdown;
